module.exports = __webpack_public_path__ + "img/notepad.9797754d.png";